import { render } from "./Bottom.vue?vue&type=template&id=d13337cc&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=d13337cc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13337cc"]])

export default __exports__